/**
 * @function init
 * @description Kick off this modules functions
 */

import BloomCloseButton from './bloom/controllers/bloom_close_button';
import MobileMenu from './navigation/controllers/mobile-menu';
import DesktopMenu from './navigation/controllers/desktop-menu';
import FixKeyboardFocusInPopups from './bloom/controllers/fix-keyboard-issue-in-popups';
import BloomEmailInput from './bloom/controllers/bloom_email_input';
import Accordion from './divi/controllers/accordion';
import FixDisclaimer from './nf/controllers/fix-disclaimer';
import DescriptiveLinks from './divi/controllers/descriptive-links';
import ProvideAriaExpandedInSubmenus from './navigation/controllers/provide-aria-expanded-in-submenus';
import enableBackToTopFocusable from './focus/back-to-top-link';
import enableAccessibleSearchForm from './search/search-form';
import enhancedAccessibleSearchForm from './search/search-form-enhanced';
import SliderImprovements from './slider/controllers/slider-improvements';
import SliderTabOrder from './slider/controllers/slider-tab-order';
import FixSocialMediaButtons from './footer/controllers/fix-social-media-buttons';
import enableFocusOnHamburgerMenuOnClosingMenu from './navigation/controllers/focus-hamburger-menu-on-closing-menu';
import BreadcrumbsFocus from './focus/breadcrumbs-focus';
import removeAnchorRoleAttribute from './remove-anchor-role-attribute';
import PracticeAreaAccordion from './practice-area-accordion';
import AttorneyTabs from './attorney-tabs';
import AttorneyToggle from './divi/controllers/attorney-toggle';
import ProvideAriaExpandedForParentmenus from './navigation/controllers/provide-aria-expanded-for-parentmenus';
import BioAccordion from './divi/controllers/bio-accordion';
import EnableAriaLabelNavMegaMenu from './navigation/controllers/enable_aria_label_nav_mega_menu';
import EnableAriaLabelNFFields from './navigation/controllers/enable_aria_lable_nf_fields';
import EnableFocusOnElementsOnTabNavigationFix from './navigation/controllers/enable_focus_on_elements_on_tab_navigation';
import AutoRotatingSliderImprovement from './slider/controllers/auto-rotating-slider-improvement';
import EnablePreventScreenReaderArrowMenus from './navigation/controllers/prevent-header-nav-menu-arrow-icons-screen-reader';
import NFFomErrorValidation from './nf/controllers/nf_a11y_validation';


const $ = jQuery;

const init = () => {
	if (($('.ENABLE_SEARCH_FORM_CLEAR_BUTTON').length > 0) && coreAccessibility.enable_search_form_clear_button) {
		enhancedAccessibleSearchForm();
	} else {
		enableAccessibleSearchForm();
	}
	const mobileMenu = new MobileMenu();
	mobileMenu.start();
	const desktopMenu = new DesktopMenu();
	desktopMenu.start();
	const bloomCloseButton = new BloomCloseButton();
	bloomCloseButton.start();
	const fixKeyboardFocusInPopups = new FixKeyboardFocusInPopups();
	fixKeyboardFocusInPopups.start();
	const bloomEmailInput = new BloomEmailInput();
	bloomEmailInput.start();
	const accordion = new Accordion();
	accordion.start();
	const fixDisclaimer = new FixDisclaimer();
	if (($('.ENABLE_NF_DISCLAIMER_A11Y').length > 0) && coreAccessibility.enable_nf_disclaimer_a11y) {
		fixDisclaimer.fixDisclaimerA11y();
	} else {
		fixDisclaimer.start();
	}
	const descriptiveLinks = new DescriptiveLinks();
	descriptiveLinks.start();
	const sliderImprovements = new SliderImprovements();
	sliderImprovements.start();
	const sliderTabOrder = new SliderTabOrder();
	sliderTabOrder.start();
	const fixSocialMediaButtons = new FixSocialMediaButtons();
	fixSocialMediaButtons.start();
	const breadcrumbsFocus = new BreadcrumbsFocus();
	breadcrumbsFocus.start();
	ProvideAriaExpandedInSubmenus();
	enableBackToTopFocusable();
	enableFocusOnHamburgerMenuOnClosingMenu();
	removeAnchorRoleAttribute();
	if (($('.ENABLE_ARIA_LABEL_MEGA_MENU_NAV_A11Y').length > 0) && coreAccessibility.enable_aria_label) {
		EnableAriaLabelNavMegaMenu();
	}

	// Practice Area Accordion Module
	const accordions = document.querySelectorAll('.menu.practice_area_menu_accordion .fl-accordion');
	accordions.forEach((accordionEl) => {
		const practiceAreaAccordion = new PracticeAreaAccordion();
		practiceAreaAccordion.start(accordionEl);
	});

	const tabLists = document.querySelectorAll('[role=tablist].fl-tabs');
	if (tabLists.length > 0) {
		tabLists.forEach((tabEl) => {
			const attorneyTabElement = new AttorneyTabs();
			attorneyTabElement.start(tabEl);
		});
	}

	const attorneytoggle = new AttorneyToggle();
	attorneytoggle.start();

	if (coreAccessibility.parentsubmenu_aria_expand_issue_fix) {
		ProvideAriaExpandedForParentmenus();
	}
	if (coreAccessibility.enable_attorney_page_accordion_fix) {
		const bioAccordion = new BioAccordion();
		bioAccordion.start();
	}
	if (coreAccessibility.enable_nf_field_generic_fix) {
		EnableAriaLabelNFFields();
	}
	if (($('.ENABLE_FOCUS_ON_ELEMENTS_ON_TAB_NAVIGATION_FIX').length > 0) && coreAccessibility.enable_focus_on_elements_on_tab_nav_fix) {
		EnableFocusOnElementsOnTabNavigationFix();
	}
	if (coreAccessibility.enable_auto_rotating_slider_issue_fix) {
		const autoRotatingSliderImprovement = new AutoRotatingSliderImprovement();
		autoRotatingSliderImprovement.start();
	}

	EnablePreventScreenReaderArrowMenus();

	const nfFomErrorValidation = new NFFomErrorValidation();
	if (($('.ENABLE_NF_FORM_ERROR_VALIDATION_A11Y_ISSUE_FIX').length > 0) && coreAccessibility.enable_nf_error_validation_issue_fix) {
		nfFomErrorValidation.start();
	}
};

export default init;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/index.js